import React, { FC, useContext } from "react";
import {
  OrganisationContext,
  OrganisationContextShape,
} from "../../../contexts/organisation";
import {
  Stack,
  Heading,
  Checkbox,
  Spacer,
  Flex,
  Link as ChakraLink,
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverBody,
} from "@chakra-ui/react";
import { useRecoilValue } from "recoil";
import { functionsState } from "../../../atoms";
import { Link as ReactRouterLink, useRouteMatch } from "react-router-dom";
import { AddFunction } from "./add-function";
import { sortBy } from "lodash";

export const OverviewFunctions: FC = () => {
  const { orgEntityIsSelected, toggleSelectOrgEntity } = useContext(
    OrganisationContext
  ) as NonNullable<OrganisationContextShape>;

  const functions = useRecoilValue(functionsState);

  const { url } = useRouteMatch();

  return (
    <Stack spacing={4}>
      <Flex align="center">
        <Heading as="h3" size="sm" fontWeight="medium">
          functies
        </Heading>

        <Spacer />

        {/* add function */}
        <Popover>
          {({ isOpen, onClose }) => (
            <>
              <PopoverTrigger>
                <Button size="xs">voeg functie toe</Button>
              </PopoverTrigger>
              <PopoverContent>
                <PopoverArrow />
                <PopoverCloseButton />
                <PopoverHeader>functie toevoegen</PopoverHeader>
                <PopoverBody>
                  {isOpen && ( // force re-render when closed
                    <AddFunction
                      onSuccess={(newFunctionId) => {
                        toggleSelectOrgEntity({
                          type: "function",
                          id: newFunctionId,
                        });
                        onClose();
                      }}
                    />
                  )}
                </PopoverBody>
              </PopoverContent>
            </>
          )}
        </Popover>
      </Flex>

      {sortBy(Object.values(functions), (func) => func.name.toLowerCase()).map(
        (func) => (
          <Flex key={func.id} align="center">
            <Checkbox
              isChecked={orgEntityIsSelected({ type: "function", id: func.id })}
              onChange={() => {
                toggleSelectOrgEntity({ type: "function", id: func.id });
              }}
            >
              {func.name}
            </Checkbox>

            <Spacer />

            <ChakraLink as={ReactRouterLink} to={`${url}/functies/${func.id}`}>
              details
            </ChakraLink>
          </Flex>
        )
      )}
    </Stack>
  );
};
